import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import Tabs from 'components/admin/Helper/Tabs'
import {
  FormCheckbox,
  FormDropdown,
  FormInput,
} from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { deleteCategory, saveCategory } from 'redux/categories'
import { confirmationModal, setDirtyFormState } from 'redux/navigation'
import { Grid, Segment } from 'semantic-ui-react'
import CategoryMedia from './CategoryMedia'
import CategoryProducts from './CategoryProducts'
import CategoryDescriptions from './CategoryDescriptions';

const i18nkey = 'admin.product.categories.'

const mapStateToProps = (state, ownProps) => {
  const {
    categories = [],
    pathLeaves,
    paths,
    categoriesLoading,
    pathsLoading,
    pathLeavesLoading,
    categoriesLoadedAt,
  } = state.categories
  const { productsLoading } = state.product
  const loading =
    categoriesLoading || pathsLoading || pathLeavesLoading || productsLoading
  return { categories, pathLeaves, paths, loading, categoriesLoadedAt }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      deleteCategory,
      saveCategory,
      setDirtyFormState,
      confirmationModal,
    },
    dispatch
  )
}

class CategoryDetail extends React.Component {
  componentWillMount() {
    const {
      categories,
      match: {
        params: { id },
      },
    } = this.props
    if (id) {
      const category = categories.find((category) => category.id === Number(id))
      if (category) {
        this.initForm(category)
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      categoriesLoadedAt: oldCategoriesLoadedAt,
      match: {
        params: { id: oldId },
      },
    } = this.props
    const {
      categoriesLoadedAt: newCategoriesLoadedAt,
      categories: newCategories,
      match: {
        params: { id: newId },
      },
    } = nextProps
    const { destroy } = this.props // reduxForm
    if (oldId !== newId || oldCategoriesLoadedAt !== newCategoriesLoadedAt) {
      if (newId) {
        const category = newCategories.find(
          (category) => category.id === Number(newId)
        )
        if (category) {
          console.debug('init form')
          this.initForm(category)
        }
      } else {
        destroy()
      }
    }
  }

  initForm(category) {
    const { initialize } = this.props // reduxForm
    const { property_filters = [], product_ids = [] } = category
    initialize({
      id: category.id,
      visible: category.visible,
      title_de: category.title_de,
      title_fr: category.title_fr,
      description_de: category.description_de,
      description_fr: category.description_fr,
      meta_description_de: category.meta_description_de,
      meta_description_fr: category.meta_description_fr,
      properties: property_filters,
      productIds: product_ids,
      headerMediumId: category.header_image_id,
      thumbnailMediumId: category.thumbnail_id,
      link_target_id: category.link_target_id,
      parent_id: category.parent_id,
    })
  }

  componentDidUpdate(prevProps) {
    const { setDirtyFormState } = this.props
    if (prevProps.dirty !== this.props.dirty)
      setDirtyFormState(this.props.dirty)
  }

  getActions() {
    const {
      categories,
      deleteCategory,
      saveCategory,
      confirmationModal, // connect
      match: {
        params: { id: categoryId },
      },
      handleSubmit,
      pristine,
      reset, //reduxForm
    } = this.props //redux
    const category =
      categories.find((category) => category.id === Number(categoryId)) || {}
    const { children = [], products = [] } = category
    return [
      {
        icon: 'cancel',
        secondary: true,
        content: I18n.t('global.cancel'),
        disabled: pristine,
        onClick: () => {
          confirmationModal({
            icon: config.icons.delete,
            negative: true,
            title: I18n.t('global.abortModal.title'),
            text: I18n.t('global.abortModal.text'),
            button: I18n.t('global.abortModal.button'),
            confirm: () => {
              reset()
            },
          })
        },
      },
      {
        icon: 'trash',
        color: 'red',
        labelPosition: 'left',
        content: I18n.t('global.delete'),
        disabled: children.length > 0 || products.length > 0,
        onClick: () => {
          confirmationModal({
            icon: config.icons.delete,
            negative: true,
            title: I18n.t('admin.product.categories.deleteModal.title'),
            text: I18n.t('admin.product.categories.deleteModal.text'),
            button: I18n.t('admin.product.categories.deleteModal.button'),
            confirm: () => {
              deleteCategory(category.id)
            },
          })
        },
      },
      {
        icon: 'checkmark',
        color: 'green',
        content: I18n.t('global.save'),
        disabled: pristine,
        onClick: handleSubmit((formValues) => {
          saveCategory(formValues)
        }),
      },
    ]
  }

  getTabs() {
    const { categories } = this.props //redux
    const { array, change } = this.props //reduxForm
    const {
      match: {
        params: { id: categoryId },
      },
    } = this.props //withRouter
    const category =
      categories.find((category) => category.id === Number(categoryId)) || {}
    const { children = [] } = category
    let tabs = []
    tabs.push('descriptions')
    if (children.length === 0) tabs.push('properties')
    tabs.push('media')
    const i18nkey = 'admin.product.categories.details.tabs.'
    const definedTabs = {
      descriptions: {
        title: I18n.t(i18nkey + 'descriptions'),
        key: 'descriptions',
        content: (<CategoryDescriptions/>)
      },
      media: {
        title: I18n.t(i18nkey + 'media'),
        key: 'media',
        content: (
          <CategoryMedia
            {...{
              change,
            }}
          />
        ),
      },
      properties: {
        title: I18n.t(i18nkey + 'properties'),
        key: 'properties',
        content: <CategoryProducts {...{ array }} />,
      },
    }

    return tabs.map((tab) => definedTabs[tab])
  }

  render() {
    const dark = config.theme.dark
    const { categories, loading, pathLeaves, paths } = this.props // redux
    const {
      match: {
        params: { id: categoryId },
      },
    } = this.props //withRouter
    const { dirty, initialized } = this.props // reduxForm
    const category =
      categories.find((category) => category.id === Number(categoryId)) || {}

    const tabsProps = {
      tabs: this.getTabs(),
      startTab: 'descriptions',
      context: 'category_details',
    }
    const headerProps = category && {
      title: I18n.t(i18nkey + 'details.title', {
        title: category.title_de,
        id: category.id,
      }),
      actions: this.getActions(),
      loading: loading,
      dirty,
    }
    const placeholderProps = {
      inactive: true,
      loading: false,
      title: I18n.t(i18nkey + 'details.title_loading'),
    }
    const linkTargetProps = {
      component: FormDropdown,
      name: 'link_target_id',
      options: pathLeaves,
      label: I18n.t(i18nkey + 'details.linked_with'),
    }
    const visibleStatusProps = {
      name: 'visible',
      component: FormCheckbox,
      label: I18n.t(i18nkey + 'visible'),
    }
    const titleDeProps = {
      name: 'title_de',
      icon: 'flag',
      component: FormInput,
      label: I18n.t('global.title_de'),
    }
    const titleFrProps = {
      name: 'title_fr',
      icon: 'flag outline',
      component: FormInput,
      label: I18n.t('global.title_fr'),
    }
    return !initialized ? (
      <ComponentPlaceholder {...placeholderProps} />
    ) : (
      <Segment
        loading={loading}
        basic
        className={classNames([
          'categoryDetails',
          'form',
          'ui',
          dark && 'inverted',
        ])}>
        <ComponentHeader {...headerProps} />
        <Segment
          attached
          className={classNames(['filterBar', dark && 'inverted'])}>
          <Grid stackable verticalAlign="middle">
            <Grid.Row>
              <Grid.Column width={8}>
                <Field {...visibleStatusProps} toggle />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>

        <Segment attached className={classNames([dark && 'inverted'])}>
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={3}>
                <Field
                  {...{
                    component: FormDropdown,
                    name: 'parent_id',
                    options: paths,
                    search: true,
                    selection: true,
                    label: I18n.t('admin.product.categories.parent_category'),
                  }}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Field {...titleDeProps} />
              </Grid.Column>
              <Grid.Column width={3}>
                <Field {...titleFrProps} />
              </Grid.Column>

              {category.link_target_id && (
                <Grid.Column width={3}>
                  <Field {...linkTargetProps} search selection />
                </Grid.Column>
              )}
            </Grid.Row>

          </Grid>
        </Segment>

        <Segment
          basic
          attached
          className={classNames(['payload', 'small', dark && 'inverted'])}>
          {!category.link_target_id && <Tabs {...tabsProps} />}
        </Segment>
      </Segment>
    )
  }
}

CategoryDetail = connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoryDetail)
CategoryDetail = reduxForm({
  form: 'category_details',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(CategoryDetail)
export default withRouter(CategoryDetail)



// WEBPACK FOOTER //
// ./src/components/admin/Categories/CategoryDetail.jsx